import { Space, Row, Col } from "antd";
import React from "react";
import Box from "../../../../../components/Box/Box";
import SummaryCard from "./SummaryCard";
import { CalendarTwoTone } from '@ant-design/icons';
import PayrollDialog from "./PayCycleForm";

const PayCycle = () => {
    const PayCycleData = {
        heading: {
            name: 'Pay Cycle',
            description: 'Running payroll on accelgrowth since october 2021',
            icon: <CalendarTwoTone />
        },
        data: [
            {
                name: 'Pay period end date',
                value: 12,
                status: true
            },
            {
                name: 'Weekly offs are paid',
                value: 'No',
                status: false
            },
            {
                name: 'Holidays are paid',
                value: 'No',
                status: false
            },
            {
                name: 'Monthly payment',
                value: 'Enabled',
                status: true
            }, {
                name: 'Daily payment',
                value: 'Enabled',
                status: true
            }
        ]
    }

    return <>
        <Space direction="vertical" style={{ width: '100%' }}>
            <PayrollDialog days={['monday', 'tuesday']}
                explainDetails=""
                handleClose={() => { }}
                open={false}
                payCycleDetails={{ payrollCycleEndDate: '', runningPayrollSince: '' }}
                remunerations="Yes" />

            <Row gutter={[16, 16]}>
                <Col span={12}>
                    <Box title={PayCycleData.heading.name}>
                        <SummaryCard data={PayCycleData} />
                    </Box>
                </Col>
            </Row>
        </Space >
    </>
}

export default PayCycle;